{
  "seriousBusiness": {
    "title": "Serious Business",
    "subtitle": "For serious people who do serious business, there are these buttons. Use them wisely."
  },
  "addFboLabel": "Add a new FBO",
  "deleteFboLabel": "Delete <u>this</u> FBO",
  "currentFbos": {
    "title": "Current FBOs",
    "subtitle": "Modify the text input to change the FBO Name. Change their subscription (gated feature access) by selecting from the dropdown."
  },
  "subscriptionLabel": "Subscription",
  "subscriptions": {
    "standard": "Standard",
    "autostacking": "Autostacking",
    "autostackingWithEdit": "Autostacking with Hangar/Ramp Edit",
    "autostackingWithEditAndCopy": "Autostacking with Hangar/Ramp Edit & Copy",
    "inactive": "Inactive"
  }
}
